import { takeLatest, all, call, fork, put } from "redux-saga/effects";
import { vmInsight } from "../../constants/actionTypes";
import {
  setVmInsightDetailsList,
  setVmInsightDetailsListError,
  setVmInsightList,
  setVmInsightListError,
  setVmInsightListLoader,
} from "../../store/actions";
import { getVmInsightDetailsApi, getVmInsightListApi } from "../api/vmInsightApi";
import { toasterFlags, errorWentWrong } from "../../constants/componentConstants";
import { toastNotification } from "../../utils/toast";
import { statusCode } from "../../constants/apis/apiStatus";

function* getVmInsightList({ data }) {
  try {
    const vmInsightListData = yield call(getVmInsightListApi, data);
    if (vmInsightListData?.status === statusCode.Ok200) {
      yield put(setVmInsightList(vmInsightListData));
    } else {
      toastNotification(toasterFlags.WARN, vmInsightListData?.data?.message);
      yield put(setVmInsightListError(vmInsightListData));
    }
  } catch (err) {
    yield put(setVmInsightListError(err));
    toastNotification(toasterFlags.WARN, errorWentWrong);
  }
  yield put(setVmInsightListLoader(false));
}

function* getVmInsightDetails({ data }) {
  try {
    const vmInsightDetailsData = yield call(getVmInsightDetailsApi, data);
    if (vmInsightDetailsData?.status === statusCode.Ok200) {
      yield put(setVmInsightDetailsList(vmInsightDetailsData));
    } else {
      toastNotification(toasterFlags.WARN, vmInsightDetailsData?.data?.message);
      yield put(setVmInsightDetailsListError(vmInsightDetailsData));
    }
  } catch (err) {
    yield put(setVmInsightDetailsListError(err));
    toastNotification(toasterFlags.WARN, errorWentWrong);
  }
  yield put(setVmInsightListLoader(false));
}

export function* vmInsightRootSaga() {
  yield takeLatest(vmInsight.GET_VM_INSIGHT_LIST, getVmInsightList);
  yield takeLatest(vmInsight.GET_VM_INSIGHT_DETAILS_LIST, getVmInsightDetails);
}

export default function* rootSaga() {
  yield all([fork(vmInsightRootSaga)]);
}
